export default __webpack_public_path__ + "static/media/real_estate_page.94cdcf9b.pdf";